const DocsTimelineIcon = () => (
  <svg style={{ width: 16, height: 'auto' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <line x1="12" y1="2" x2="12" y2="22"/>
    <circle cx="12" cy="6" r="2" fill="currentColor" stroke="none" opacity="0.3"/>
    <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" opacity="0.3"/>
    <circle cx="12" cy="18" r="2" fill="currentColor" stroke="none" opacity="0.3"/>
    <rect x="15" y="4" width="6" height="4" rx="1"/>
    <rect x="15" y="10" width="6" height="4" rx="1"/>
    <rect x="15" y="16" width="6" height="4" rx="1"/>
  </svg>
);

export default DocsTimelineIcon;
